export default "__VITE_ASSET__CTJdwI87__"